exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-tags-input[data-v-7ca56012] {\n  max-width: 100%;\n}\n.ti-input[data-v-7ca56012] {\n  border-radius: 0.35rem !important;\n  border: 1px solid #d1d3e2 !important;\n}", ""]);

// exports
